// Language options
export const LANGUAGE_OPTIONS = [
  { value: 'arabic', label: 'عربي' },
  { value: 'english', label: 'إنجليزي' },
  { value: 'mixed', label: 'مختلط (عربي + إنجليزي)' }
];

// Tone options
export const TONE_OPTIONS = [
  { value: 'professional', label: 'احترافي' },
  { value: 'friendly', label: 'ودي' },
  { value: 'motivational', label: 'تحفيزي' },
  { value: 'educational', label: 'تعليمي' },
  { value: 'storytelling', label: 'قصصي' },
  { value: 'thought_leadership', label: 'قيادة فكرية' },
  { value: 'conversational', label: 'محادثاتي' }
];

// Main topic categories
export const TOPIC_OPTIONS = [
  // Technology & Programming - التقنية والبرمجة
  { value: 'artificial_intelligence', label: 'الذكاء الاصطناعي', category: 'التقنية' },
  { value: 'programming', label: 'البرمجة والتطوير', category: 'التقنية' },
  { value: 'data_science', label: 'علم البيانات', category: 'التقنية' },
  { value: 'cybersecurity', label: 'الأمن السيبراني', category: 'التقنية' },
  { value: 'blockchain', label: 'البلوكتشين', category: 'التقنية' },
  { value: 'cloud_computing', label: 'الحوسبة السحابية', category: 'التقنية' },
  { value: 'mobile_development', label: 'تطوير تطبيقات الجوال', category: 'التقنية' },
  { value: 'web_development', label: 'تطوير الويب', category: 'التقنية' },
  { value: 'software_architecture', label: 'هندسة البرمجيات', category: 'التقنية' },
  { value: 'devops', label: 'DevOps وCI/CD', category: 'التقنية' },

  // Enterprise Software & SAP - أنظمة المؤسسات وSAP
  { value: 'sap_consulting', label: 'استشارات SAP', category: 'SAP والأنظمة' },
  { value: 'sap_s4hana', label: 'SAP S/4HANA', category: 'SAP والأنظمة' },
  { value: 'sap_implementation', label: 'تنفيذ SAP', category: 'SAP والأنظمة' },
  { value: 'erp_systems', label: 'أنظمة ERP', category: 'SAP والأنظمة' },
  { value: 'sap_migration', label: 'ترحيل SAP', category: 'SAP والأنظمة' },
  { value: 'sap_integration', label: 'تكامل SAP', category: 'SAP والأنظمة' },
  { value: 'sap_analytics', label: 'تحليلات SAP وBI', category: 'SAP والأنظمة' },
  { value: 'sap_automation', label: 'أتمتة SAP', category: 'SAP والأنظمة' },
  { value: 'enterprise_software', label: 'برمجيات المؤسسات', category: 'SAP والأنظمة' },
  { value: 'system_optimization', label: 'تحسين الأنظمة', category: 'SAP والأنظمة' },

  // Business & Entrepreneurship - الأعمال وريادة الأعمال
  { value: 'entrepreneurship', label: 'ريادة الأعمال', category: 'الأعمال' },
  { value: 'startups', label: 'الشركات الناشئة', category: 'الأعمال' },
  { value: 'business_strategy', label: 'استراتيجية الأعمال', category: 'الأعمال' },
  { value: 'digital_transformation', label: 'التحول الرقمي', category: 'الأعمال' },
  { value: 'project_management', label: 'إدارة المشاريع', category: 'الأعمال' },
  { value: 'innovation', label: 'الابتكار', category: 'الأعمال' },
  { value: 'finance', label: 'المالية والاستثمار', category: 'الأعمال' },
  { value: 'ecommerce', label: 'التجارة الإلكترونية', category: 'الأعمال' },

  // Career & Professional Development - المسار المهني والتطوير
  { value: 'career_development', label: 'التطوير المهني', category: 'المهني' },
  { value: 'leadership', label: 'القيادة والإدارة', category: 'المهني' },
  { value: 'skills_development', label: 'تطوير المهارات', category: 'المهني' },
  { value: 'networking', label: 'التواصل المهني', category: 'المهني' },
  { value: 'remote_work', label: 'العمل عن بُعد', category: 'المهني' },
  { value: 'work_life_balance', label: 'التوازن بين العمل والحياة', category: 'المهني' },
  { value: 'job_search', label: 'البحث عن عمل', category: 'المهني' },
  { value: 'interview_skills', label: 'مهارات المقابلات', category: 'المهني' },

  // Marketing & Sales - التسويق والمبيعات
  { value: 'digital_marketing', label: 'التسويق الرقمي', category: 'التسويق' },
  { value: 'social_media', label: 'وسائل التواصل الاجتماعي', category: 'التسويق' },
  { value: 'content_marketing', label: 'تسويق المحتوى', category: 'التسويق' },
  { value: 'branding', label: 'بناء العلامة التجارية', category: 'التسويق' },
  { value: 'seo', label: 'تحسين محركات البحث', category: 'التسويق' },
  { value: 'sales_strategy', label: 'استراتيجية المبيعات', category: 'التسويق' },

  // Personal Development - التطوير الشخصي
  { value: 'productivity', label: 'الإنتاجية', category: 'شخصي' },
  { value: 'time_management', label: 'إدارة الوقت', category: 'شخصي' },
  { value: 'learning', label: 'التعلم والتطوير', category: 'شخصي' },
  { value: 'mindset', label: 'العقلية', category: 'شخصي' },
  { value: 'motivation', label: 'التحفيز', category: 'شخصي' },
  { value: 'success_stories', label: 'قصص النجاح', category: 'شخصي' },

  // Industry Specific - قطاعات محددة
  { value: 'healthcare', label: 'الرعاية الصحية', category: 'القطاعات' },
  { value: 'education', label: 'التعليم', category: 'القطاعات' },
  { value: 'manufacturing', label: 'التصنيع', category: 'القطاعات' },
  { value: 'real_estate', label: 'العقارات', category: 'القطاعات' },
  { value: 'consulting', label: 'الاستشارات', category: 'القطاعات' },
  { value: 'hr', label: 'الموارد البشرية', category: 'القطاعات' }
];

// Length options
export const LENGTH_OPTIONS = [
  { value: 'short', label: 'قصير (100-200 كلمة)' },
  { value: 'medium', label: 'متوسط (200-400 كلمة)' },
  { value: 'long', label: 'طويل (400-600 كلمة)' },
  { value: 'custom', label: 'مخصص' }
];

// Status options
export const STATUS_OPTIONS = [
  { value: 'draft', label: 'مسودة' },
  { value: 'refined', label: 'محسّن' },
  { value: 'final', label: 'نهائي' }
];

// Character count thresholds
export const CHARACTER_LIMITS = {
  SHORT: { min: 0, max: 1300, status: 'warning', message: 'قصير جداً' },
  IDEAL: { min: 1300, max: 2000, status: 'success', message: 'مثالي للينكد إن' },
  LONG: { min: 2000, max: 3000, status: 'warning', message: 'طويل قليلاً' },
  TOO_LONG: { min: 3000, max: Infinity, status: 'error', message: 'طويل جداً - قد يتم اقتطاعه' }
};

// Local storage keys
export const STORAGE_KEYS = {
  DRAFT: 'linkedin_post_draft',
  SETTINGS: 'linkedin_post_settings',
  LAST_FORM_DATA: 'linkedin_post_last_form'
};
